import { useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import api from "../../../services/api";

const fmt  = (v) => parseFloat(v||0).toLocaleString("pt-BR",{minimumFractionDigits:2,maximumFractionDigits:2});
const fmt4 = (v) => parseFloat(v||0).toLocaleString("pt-BR",{minimumFractionDigits:2,maximumFractionDigits:4});
const n    = (v) => parseFloat(v) || 0;

const Campo = ({label, children}) => (
  <div className="form-group">
    <label className="form-label">{label}</label>
    {children}
  </div>
);

const PreviewBox = ({children}) => (
  <div style={{background:"#eef2ff",border:"1px solid #c7d2fe",borderRadius:6,padding:"10px 14px",marginBottom:12,fontSize:12,display:"flex",gap:20,flexWrap:"wrap"}}>
    {children}
  </div>
);

const PreviewItem = ({label, value, destaque}) => (
  <span style={{color: destaque?"var(--z-blue)":"inherit"}}>
    {label}: <strong>{value}</strong>
  </span>
);

const FormProcesso = forwardRef(function FormProcesso({produto, maquinas, funcionarios, allProdutos, onSalvo}, ref) {
  const det   = produto.processo_detalhe || {};
  const detId = det.id || null;
  const cat   = produto.categoria;

  const [form, setForm] = useState({
    produto:            produto.id,
    maquina:            det.maquina            || "",
    funcionario:        det.funcionario         || "",
    // Injecao
    tempo_ciclo_seg:    det.tempo_ciclo_seg     || "",
    cavidades:          det.cavidades           || 1,
    peso_peca_g:        det.peso_peca_g         || "",
    peso_galha_g:       det.peso_galha_g        || "",
    plastico:           det.plastico            || "",
    perc_aditivo:       det.perc_aditivo        || 0,
    aditivo:            det.aditivo             || "",
    // Corte
    perfil_aluminio:    det.perfil_aluminio     || "",
    comprimento_peca_m: det.comprimento_peca_m  || "",
    perda_pontal_perc:  det.perda_pontal_perc   || 0,
    tempo_corte_seg:    det.tempo_corte_seg     || "",
    // Trancagem
    fio:                det.fio                 || "",
    metros_produzidos:  det.metros_produzidos   || "",
    tempo_rodando_min:  det.tempo_rodando_min   || "",
    qtd_fios:           det.qtd_fios            || 0,
    perda_setup_kg:     det.perda_setup_kg      || 0,
  });

  const [salvando, setSalvando] = useState(false);
  const [preview, setPreview]   = useState({});

  const upd = (field) => (e) => setForm(v => ({...v, [field]: e.target.value}));

  const maqFiltradas = (tipo) => maquinas.filter(m => m.tipo === tipo);
  const plasticos    = allProdutos.filter(p => p.categoria === "MATERIA_PRIMA" && p.tipo === "PLASTICO_GR");
  const fios         = allProdutos.filter(p => p.tipo === "FIO");
  const perfis       = allProdutos.filter(p => p.tipo === "ALUMINIO");

  useEffect(() => {
    const maq   = maquinas.find(m => m.id === parseInt(form.maquina));
    const func  = funcionarios.find(f => f.id === parseInt(form.funcionario));
    const maqH  = maq  ? n(maq.custo_hora) : 0;
    const funcH = func ? n(func.custo_hora) : 0;
    const maqOp = maq  ? n(maq.maquinas_por_operador) || 1 : 1;

    if (cat === "CORTE_BARRA_ALU") {
      const perfil = allProdutos.find(p => p.id === parseInt(form.perfil_aluminio));
      const comp   = n(form.comprimento_peca_m);
      const tempoH = n(form.tempo_corte_seg) / 3600;
      if (!perfil || comp <= 0) { setPreview({}); return; }
      const compBarra    = n(perfil.comprimento_barra) || 6;
      const custoBarra   = n(perfil.preco_custo);
      const pecasBarra   = Math.floor(compBarra / comp);
      const sobra        = compBarra - (pecasBarra * comp);
      const custoMat     = pecasBarra > 0 ? custoBarra / pecasBarra : 0;
      const custoMO      = tempoH * funcH;
      const custoMaq     = tempoH * maqH;
      setPreview({ custo: custoMat+custoMO+custoMaq, pecasBarra, sobra, custoBarra, custoMat, custoMO, custoMaq });
    }
    else if (cat === "INJECAO_PLASTICA") {
      const plastico = allProdutos.find(p => p.id === parseInt(form.plastico));
      const ciclo    = n(form.tempo_ciclo_seg);
      const cav      = parseInt(form.cavidades) || 1;
      const pesoPeca = n(form.peso_peca_g);
      if (!ciclo || !pesoPeca) { setPreview({}); return; }
      const custoKg  = plastico ? n(plastico.preco_custo) : 0;
      const pesoKg   = (pesoPeca * cav + n(form.peso_galha_g)) / 1000;
      const custoMat = (pesoKg * custoKg) / cav;
      const custoMO  = (ciclo / cav / 3600) * (funcH / maqOp);
      const custoMaq = (ciclo / 3600) * maqH / cav;
      setPreview({ custo: custoMat+custoMO+custoMaq, custoMat, custoMO, custoMaq });
    }
    else if (cat === "TRANCAGEM_CORDA") {
      const fio    = allProdutos.find(p => p.id === parseInt(form.fio));
      const metros = n(form.metros_produzidos);
      const tempo  = n(form.tempo_rodando_min);
      if (!metros || !tempo) { setPreview({}); return; }
      const custoKgFio = fio ? n(fio.preco_custo) : 0;
      const gramaMetro = fio ? n(fio.grama_metro) : 0;
      const numFios    = parseInt(form.qtd_fios) || 1;
      const pesoMetro  = (gramaMetro * numFios) / 1000;
      const custoMatM  = custoKgFio * pesoMetro;
      const metrosH    = metros / (tempo / 3600);
      const custoMOM   = metrosH > 0 ? (funcH / maqOp) / metrosH : 0;
      const custoMaqM  = metrosH > 0 ? maqH / metrosH : 0;
      setPreview({ custo: custoMatM+custoMOM+custoMaqM, custoMatM, custoMOM, custoMaqM, metrosH });
    }
  }, [form.maquina, form.funcionario, form.perfil_aluminio, form.comprimento_peca_m,
      form.tempo_corte_seg, form.tempo_ciclo_seg, form.cavidades, form.peso_peca_g,
      form.peso_galha_g, form.plastico, form.fio, form.metros_produzidos, form.tempo_rodando_min]);

  const salvar = async () => {
setSalvando(true);
    const dados = {
      ...form,
      tempo_ciclo_seg:    n(form.tempo_ciclo_seg),
      peso_peca_g:        n(form.peso_peca_g),
      peso_galha_g:       n(form.peso_galha_g),
      tempo_corte_seg:    n(form.tempo_corte_seg),
      comprimento_peca_m: n(form.comprimento_peca_m),
      perda_pontal_perc:  n(form.perda_pontal_perc),
      metros_produzidos:  n(form.metros_produzidos),
      tempo_rodando_min:  n(form.tempo_rodando_min),
      perda_setup_kg:     n(form.perda_setup_kg),
      perc_aditivo:       n(form.perc_aditivo),
      cavidades:          parseInt(form.cavidades) || 1,
      qtd_fios:           parseInt(form.qtd_fios)  || 0,
      maquina:         form.maquina        || null,
      funcionario:     form.funcionario    || null,
      plastico:        form.plastico       || null,
      aditivo:         form.aditivo        || null,
      perfil_aluminio: form.perfil_aluminio|| null,
      fio:             form.fio            || null,
    };
    try {
      if (detId) await api.put("/produtos/processo-detalhe/"+detId+"/", dados);
      else       await api.post("/produtos/processo-detalhe/", dados);
      onSalvo();
    } catch(e) {
      alert(e.response?.data ? JSON.stringify(e.response.data) : "Erro ao salvar processo.");
    } finally { setSalvando(false); }
  };

  const Sel = ({label, field, options}) => (
    <Campo label={label}>
      <select className="form-select" value={form[field]||""} onChange={upd(field)}>
        <option value="">-- Selecione --</option>
        {options.map(o => <option key={o.id} value={o.id}>{o.label}</option>)}
      </select>
    </Campo>
  );
  const Inp = ({label, field}) => (
    <Campo label={label}>
      <input className="form-input" type="number" value={form[field]||""} onChange={upd(field)} />
    </Campo>
  );

  const funcOpts  = funcionarios.map(f=>({id:f.id, label:`${f.nome} (R$${fmt4(f.custo_hora)}/h)`}));
  const corteOpts = maqFiltradas("CORTE").map(m=>({id:m.id, label:`${m.nome} (R$${fmt4(m.custo_hora)}/h)`}));
  const injOpts   = maqFiltradas("INJETORA").map(m=>({id:m.id, label:`${m.nome} (R$${fmt4(m.custo_hora)}/h)`}));
  const trcOpts   = maqFiltradas("TRANCADEIRA").map(m=>({id:m.id, label:`${m.nome} (R$${fmt4(m.custo_hora)}/h)`}));
  const perfisOpts= perfis.map(m=>({id:m.id, label:`${m.nome} (${fmt4(m.kg_metro)}kg/m | ${fmt4(m.comprimento_barra)}m)`}));
  const ppOpts    = plasticos.map(m=>({id:m.id, label:`${m.nome} — R$${fmt4(m.preco_custo)}/kg`}));
  const fioOpts   = fios.map(m=>({id:m.id, label:`${m.nome} — R$${fmt4(m.preco_custo)}/kg (${fmt4(m.grama_metro)}g/m)`}));

  return (
    <div>

      {/* CORTE DE ALUMINIO */}
      {cat === "CORTE_BARRA_ALU" && (
        <>
          <div style={{display:"grid", gridTemplateColumns:"1fr 1fr 2fr 0.7fr 0.7fr", gap:12, marginBottom:12}}>
            <Sel label="Funcionario"     field="funcionario"     options={funcOpts} />
            <Sel label="Maquina Corte"   field="maquina"         options={corteOpts} />
            <Sel label="Perfil / Barra"  field="perfil_aluminio" options={perfisOpts} />
            <Inp label="Comprimento (m)" field="comprimento_peca_m" />
            <Inp label="Tempo corte (s)" field="tempo_corte_seg" />
          </div>
          {preview.pecasBarra > 0 && (
            <PreviewBox>
              <PreviewItem label="Pecas/barra"    value={preview.pecasBarra} />
              <PreviewItem label="Sobra"           value={fmt4(preview.sobra)+" m"} />
              <PreviewItem label="Custo barra"     value={"R$ "+fmt(preview.custoBarra)} />
              <PreviewItem label="Material/peca"   value={"R$ "+fmt4(preview.custoMat)} />
              {preview.custoMO  > 0 && <PreviewItem label="MO/peca"  value={"R$ "+fmt4(preview.custoMO)} />}
              {preview.custoMaq > 0 && <PreviewItem label="Maq/peca" value={"R$ "+fmt4(preview.custoMaq)} />}
            </PreviewBox>
          )}
        </>
      )}

      {/* INJECAO PLASTICA */}
      {cat === "INJECAO_PLASTICA" && (
        <>
          <div style={{display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:12, marginBottom:8}}>
            <Sel label="Funcionario"    field="funcionario" options={funcOpts} />
            <Sel label="Injetora"       field="maquina"     options={injOpts} />
            <Sel label="Plastico (PP)"  field="plastico"    options={ppOpts} />
            <Sel label="Aditivo"        field="aditivo"     options={ppOpts} />
            <Inp label="Tempo ciclo (s)"field="tempo_ciclo_seg" />
            <Inp label="Cavidades"      field="cavidades" />
            <Inp label="Peso peca (g)"  field="peso_peca_g" />
            <Inp label="Peso galha (g)" field="peso_galha_g" />
            <Inp label="% Aditivo"      field="perc_aditivo" />
          </div>
          {preview.custo > 0 && (
            <PreviewBox>
              <PreviewItem label="Material/peca" value={"R$ "+fmt4(preview.custoMat)} />
              {preview.custoMO  > 0 && <PreviewItem label="MO/peca"  value={"R$ "+fmt4(preview.custoMO)} />}
              {preview.custoMaq > 0 && <PreviewItem label="Maq/peca" value={"R$ "+fmt4(preview.custoMaq)} />}
            </PreviewBox>
          )}
        </>
      )}

      {/* TRANCAGEM DE CORDA */}
      {cat === "TRANCAGEM_CORDA" && (
        <>
          <div style={{display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:12, marginBottom:8}}>
            <Sel label="Funcionario"       field="funcionario"      options={funcOpts} />
            <Sel label="Trancadeira"       field="maquina"          options={trcOpts} />
            <Sel label="Fio PP"            field="fio"              options={fioOpts} />
            <Inp label="Metros produzidos" field="metros_produzidos" />
            <Inp label="Tempo rodando (seg)"field="tempo_rodando_min" />
            <Inp label="Numero de fios"         field="qtd_fios" />
            <Inp label="Perda setup (kg)"  field="perda_setup_kg" />
          </div>
          {preview.metrosH > 0 && (
            <PreviewBox>
              <PreviewItem label="Velocidade"    value={fmt4(preview.metrosH)+" m/h"} />
              <PreviewItem label="Peso/metro"    value={fmt4((n(allProdutos.find(p=>p.id===parseInt(form.fio))?.grama_metro)||0) * (parseInt(form.qtd_fios)||1) / 1000)+" kg/m"} />
              <PreviewItem label="Material/metro"value={"R$ "+fmt4(preview.custoMatM)} />
              {preview.custoMOM  > 0 && <PreviewItem label="MO/metro"  value={"R$ "+fmt4(preview.custoMOM)} />}
              {preview.custoMaqM > 0 && <PreviewItem label="Maq/metro" value={"R$ "+fmt4(preview.custoMaqM)} />}
            </PreviewBox>
          )}
        </>
      )}

      {/* RODAPE */}
      <div style={{display:"flex",gap:16,alignItems:"center",paddingTop:8,borderTop:"1px solid var(--z-border)",flexWrap:"wrap"}}>

        {preview.custo > 0 && (
          <span style={{fontSize:13,fontWeight:700,color:"var(--z-blue)"}}>
            Custo estimado: R$ {fmt4(preview.custo)}/un
          </span>
        )}
        {detId && <span style={{fontSize:11,color:"var(--z-text-muted)"}}>Processo #{detId}</span>}
      </div>

    </div>
  );
});

export default FormProcesso;
